import { render, staticRenderFns } from "./SettingsProducts.vue?vue&type=template&id=23efa5e2&scoped=true"
import script from "./SettingsProducts.vue?vue&type=script&lang=js"
export * from "./SettingsProducts.vue?vue&type=script&lang=js"
import style0 from "./SettingsProducts.vue?vue&type=style&index=0&id=23efa5e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23efa5e2",
  null
  
)

export default component.exports